export const calculateShutterbTotal = (
  event = {},
  shutterb = {},
  eventBookingStatus
) => {
  const {
    status,
    tipPrice_,
    hourlyRate,
    oldHourlyRate,
    extendedPrice_,
    extendedQuantity_,
    isDurationIncrease,
  } = shutterb;

  const { duration = 0, oldDuration = 0 } = event;

  // Tip case
  if (tipPrice_) return tipPrice_;

  // Extended price case
  if (extendedPrice_) {
    return extendedQuantity_ * extendedPrice_;
  }

  // Duration increase case
  if (isDurationIncrease) {
    return duration * hourlyRate;
  }

  // Cancelled case
  if (status === eventBookingStatus.CANCEL) {
    return oldDuration * hourlyRate;
  }

  // Default case
  return duration * oldHourlyRate;
};

export const isDeletedRow = (orderItems, eventBookingStatus, shutterB) => {
  const allType2 =
    orderItems?.length > 0 &&
    orderItems.every((oi) => oi.orderItemTypeId === 2 || oi.sbUserId);

  const hasOtherStatuses = orderItems?.some(
    (oi) =>
      oi.status !== eventBookingStatus.CANCEL &&
      oi.status !== eventBookingStatus.NOTIFY_ADMIN
  );

  const isDeletedRow =
    (allType2 && shutterB?.status === eventBookingStatus.CANCEL) ||
    (hasOtherStatuses && shutterB?.status === eventBookingStatus.NOTIFY_ADMIN);

  return isDeletedRow;
};

export const getQuantity = (
  event = {},
  shutterb = {},
  DEFAULT_VALUE,
  eventBookingStatus,
  old
) => {
  const { status, tipPrice_, extendedQuantity_ } = shutterb;
  const { duration = 0, oldDuration = 0 } = event;

  // Tip case
  if (tipPrice_) return DEFAULT_VALUE;

  // Extended case
  if (extendedQuantity_) return extendedQuantity_;

  // Cancelled case
  if (status === eventBookingStatus.CANCEL) return oldDuration;

  // Default case
  if (old && duration !== oldDuration) {
    return oldDuration;
  } else {
    return duration;
  }
};
